/* eslint-disable no-process-env */
import { parseBoolean } from "../commons/BooleanHelper";

export const Settings = {
  DOMAIN_CONFIG_API: process.env.REACT_APP_DOMAIN_CONFIG_API,
  PARKWEB_LANDER_API: process.env.REACT_APP_PARKWEB_LANDER_API,
  EVENT_PUBLISH_API: process.env.REACT_APP_EVENT_PUBLISH_API,
  GODADDY_HOST: process.env.REACT_APP_GODADDY_HOST,
  GOOGLE_ADSENSE_ADTEST: process.env.REACT_APP_ADSENSE_ADTEST,
  DEBUG_MODE: parseBoolean(process.env.REACT_APP_DEBUG_MODE),
  YAHOO_FEED_PARTNER: {
    TEST: process.env.REACT_APP_YAHOO_FEED_PARTNER_TEST,
  },
  YAHOO_SINGLE_LANDER_PARTNER: {
    SEARCH_DOMAIN_PARKING:
      process.env.REACT_APP_YAHOO_FEED_SINGLE_LANDER_SEARCH,
    GENERAL_DOMAIN_PARKING:
      process.env.REACT_APP_YAHOO_FEED_SINGLE_LANDER_GENERAL,
    UNIVERSAL_DOMAIN_PARKING:
      process.env.REACT_APP_YAHOO_FEED_SINGLE_LANDER_UNIVERSAL,
    MISCELLANEOUS_DOMAIN_PARKING:
      process.env.REACT_APP_YAHOO_FEED_SINGLE_LANDER_MISCELLANEOUS,
    GENERIC_DOMAIN_PARKING:
      process.env.REACT_APP_YAHOO_FEED_SINGLE_LANDER_GENERIC,
  },
  YAHOO_FEED_PROXY: process.env.REACT_APP_YAHOO_FEED_PROXY,
  YAHOO_FEED_PATH:
    process.env.REACT_APP_YAHOO_FEED_PROXY +
    "/d/search/p/godaddy/xml/domain/multiset/v4/",
  PRIVACY_POLICY_URL:
    "https://www.godaddy.com/agreements/showdoc?pageid=PRIVACY",
  ForwarderLanderToUrl: {
    DAN: process.env.REACT_APP_FORWARDER_LANDER_URL_DAN,
    TDFS_GD: process.env.REACT_APP_FORWARDER_LANDER_URL_TDFS_GD,
    TDFS_AFTERNIC: process.env.REACT_APP_FORWARDER_LANDER_URL_TDFS_AFTERNIC,
  },
  FORWARDER_LANDER_API: process.env.REACT_APP_FORWARDER_LANDER_API,
  NORMAL_DOMAIN_LENGTH_LIMIT: 20,
  CONSENT_MANAGER_JS: process.env.REACT_APP_CONSENT_MANAGER_JS,
  CONSENT_MANAGER_CSS: process.env.REACT_APP_CONSENT_MANAGER_CSS,
  PARKING_ENV: process.env.REACT_APP_PARKING_ENV,
  TRUSTARC_SCRIPT_URI: process.env.REACT_APP_TRUSTARC_SCRIPT_URI,
  TRUSTARC_DOMAIN_ID: process.env.REACT_APP_TRUSTARC_DOMAIN_ID,
  TRUSTPILOT_URL: process.env.REACT_APP_TRUSTPILOT_URL,
  TRUSTPILOT_BUSINESS_UNIT_ID: process.env.REACT_APP_TRUSTPILOT_ID,
  ACTION_SERVICE: process.env.REACT_APP_ACTION_SERVICE,
  UNIVERSAL_AD_WIDGET_CONFIG: {
    env: process.env.REACT_APP_PARKING_ENV,
    adServerBaseUrl: process.env.REACT_APP_UAW_BASE_URL,
    placements: {
      "gd-parking-lander-pos1": {
        customProperties: {
          categoryRestriction: "all_offers.affiliate_partner_deals.*",
        },
        kevelPlacementConfig: {
          siteId: parseInt(process.env.REACT_APP_UAW_SITE_ID, 10),
          zoneId: parseInt(process.env.REACT_APP_UAW_ZONE_ID, 10),
          count: 3,
        },
      },
    },
  },
};
export const ENVS = {
  PROD: "prod",
  STAGE: "stage",
  DEV_PRIVATE: "dev-private",
  TEST: "test",
};
